class ClosedPeriod {
  startDate;
  endDate;
  isClosed;
}

export default ClosedPeriod;
